import apiClient from '../apiClient';

class JobSeekerProfileService {
  constructor(user) {
    this.user = user;
  }

  toBackendFormat(data) {
    const { id, auth0Id, createdAt, updatedAt, ...rest } = data;
    return rest;
  }

  fromBackendFormat(data) {
    return data;
  }

  async createRecord(data) {
    const backendData = this.toBackendFormat(data);
    const response = await apiClient.post('/job-seeker-profiles', backendData);
    return this.fromBackendFormat(response);
  }

  async createOrUpdateRecord(data) {
    const existingRecord = await this.getRecordsByUserId(data.userId);
    if (existingRecord) {
      return await this.updateRecord(existingRecord.id, data);
    } else {
      return await this.createRecord(data);
    }
  }

  async getRecordsByUserId(userId) {
    try {
      const response = await apiClient.get('/job-seeker-profiles/me');
      return response ? this.fromBackendFormat(response) : null;
    } catch (err) {
      // Re-throw rate limit errors so they can be handled by the caller
      if (err?.status === 429) {
        throw err;
      }
      return null;
    }
  }

  async getRecordById(recordId) {
    const response = await apiClient.get(`/job-seeker-profiles/${recordId}`);
    return this.fromBackendFormat(response);
  }

  // Fetch server-side roadmap/score for current authenticated user
  async getMyRoadmap() {
    return apiClient.get('/job-seeker-profiles/me/score');
  }

  // Fetch server-side roadmap/score for a specific profile id
  async getRoadmapByProfileId(profileId) {
    if (!profileId) throw new Error('profileId is required');
    return apiClient.get(`/job-seeker-profiles/${profileId}/score`);
  }

  async updateRecord(recordId, data) {
    const backendData = this.toBackendFormat(data);
    const response = await apiClient.put(`/job-seeker-profiles/${recordId}`, backendData);
    return this.fromBackendFormat(response);
  }
}

export default JobSeekerProfileService;